/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Billing_Openportal1Inputs */

const zh_billing_openportal1 = /** @type {(inputs: Billing_Openportal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开账单门户`)
};

const en_billing_openportal1 = /** @type {(inputs: Billing_Openportal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open Billing Portal`)
};

const es_billing_openportal1 = /** @type {(inputs: Billing_Openportal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir portal de facturación`)
};

/**
* | output |
* | --- |
* | "Open Billing Portal" |
*
* @param {Billing_Openportal1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const billing_openportal1 = /** @type {((inputs?: Billing_Openportal1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Billing_Openportal1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_billing_openportal1(inputs)
	if (locale === "en") return en_billing_openportal1(inputs)
	return es_billing_openportal1(inputs)
});
export { billing_openportal1 as "billing_openPortal" }